
export async function getJaneSpecials(store, type) {
  if (!store) {
    console.log("No store value");
    return;
  }
  try {
    const response = await fetch(`/api/jane-specials?store=${store}&type=${type}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch specials: ${response.status}`);
    }
    const data = await response.json();
    return data.specials;
  } catch (error) {
    console.error("Error fetching specials:", error);
  }
}

export async function getAllJaneSpecials(store) {
  if (!store) {
    console.log("No store value");
    return;
  }

  try {
    // Make fetch requests for both product and bundle types
    const [productResponse, bundleResponse] = await Promise.all([
      fetch(`/api/jane-specials?store=${store}&type=product`),
      fetch(`/api/jane-specials?store=${store}&type=bundle`),
    ]);

    // Check for response errors
    if (!productResponse.ok || !bundleResponse.ok) {
      throw new Error(
        `Failed to fetch specials: ${
          !productResponse.ok ? `Product - ${productResponse.status}` : ""
        } ${!bundleResponse.ok ? `Bundle - ${bundleResponse.status}` : ""}`
      );
    }

    // Parse the JSON responses
    const productData = await productResponse.json();
    const bundleData = await bundleResponse.json();

    // Combine the specials from both responses
    const allSpecials = [
      ...(productData.specials || []),
      ...(bundleData.specials || []),
    ];

    return allSpecials;
  } catch (error) {
    console.error("Error fetching specials:", error);
    return [];
  }
}

export async function getToken() {
  try {
    const clientId = process.env.JANE_CLIENT_ID;
    const clientSecret = process.env.JANE_CLIENT_SECRET;

    const result = await fetch(
      `https://www.iheartjane.com/api/oauth/token?grant_type=client_credentials&client_id=${clientId}&client_secret=${clientSecret}`,
      {
        method: 'POST',
        headers: {
          accept: 'application/json',
        },
      }
    );

    if (!result.ok) {
      throw new Error(`Error fetching token: ${result.status}`);
    }

    const data = await result.json();
    return data.access_token;
  } catch (error) {
    console.error('Error retrieving token:', error);
    throw error;
  }
}

export async function getProductById({ id, unique_slug }) {
  const token = await getToken();
  const identifier = unique_slug || id;

  if (!identifier) {
    throw new Error('Either unique_slug or id is required.');
  }

  const url = `https://api.iheartjane.com/roots/store_operations_api/v1/menu_products/menu_product_slug?slug_or_product_id=${identifier}&store_ids=117&store_ids=5981`;

  const result = await fetch(url, {
    headers: {
      credentials: 'include',
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!result.ok) {
    throw new Error(`Failed to fetch product (status: ${result.status})`);
  }

  const data = await result.json();

  // Unwrap and normalize the response
  const product = data.menu_product || data;

  return {
    ...product,
    store_notes: data.store_notes || null,
    source: 'api',
    product_id: product.product_id || product.id || id,
    unique_slug: product.unique_slug || unique_slug,
  };
}
